export class LoginModel {
    loginId = "";
    password = "";
    appJsHash = "";
    vendorJsHash = "";
}
